var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpenedContactsViewerVisible)?_c('div',{staticClass:"opened-contacts-viewer",class:{
    shifted: _vm.isShiftedByRightMenu,
  }},_vm._l((_vm.openedContactCards),function(contactCard){return _c('opened-contact-card',{key:'contactCard_' + contactCard.contactId,attrs:{"contact-id":contactCard.contactId}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }